import * as React from 'react';
import { Form } from './components/Form';
import { getSettings } from '@app/src/configuration/config.service';

export const Login = ({ history }) => {

  sessionStorage.clear();

  return(
    <Form
      history={history}
      urlLogin={getSettings().API_LOGIN}
      urlRecoverPassword={getSettings().API_RECOVER_PASSWORD}
    />
  );
};

